import React from 'react'
import certificate from '../../../assets/section_new_images/exploremore/certificate.png'

const Certificate = () => {
  return (
    <div className='container pb-5 px-2 px-md-5 row align-items-center justify-content-center certificate_container'>
        <img src={certificate} alt='certificate' />
    </div>
  )
}

export default Certificate